export const COUNTRY_REPORT_ID = 'country';
